import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Device } from '@capacitor/device';

@Component({
  selector: '',
  template: '',
  styleUrls: []
})
export class PaymentComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  async ngOnInit() {
    const { platform } = await Device.getInfo();
    if (platform === 'web') {
      this.router.navigate(['/'], { queryParams: { reload_after_payment: '1' } });
      return;
    }

    const { subscription_id } = this.route.snapshot.queryParams;
    if (subscription_id) {
      window.close();
      return;
    }

    this.router.navigate(['/'], { queryParams: { reload_after_payment: '1' } });
  }

}
